module.exports = __webpack_public_path__ + "static/media/signup.3516b1cb.png";